/* import __COLOCATED_TEMPLATE__ from './limit-reached-hover-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();